import { connect } from "react-redux";

import DatePicker from 'react-datepicker';
import moment from 'moment';

var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var Features = require("lib/account/Features");
var ValidatingInput = require("components/utility/ValidatingInput");
var StudentMetrics = require("lib/data/StudentMetrics");
var ErrorDisplay = require("components/utility/ErrorDisplay")
var OrgTypes = require("lib/academic/OrgTypes");

var QuizCustomization = require("lib/academic/QuizCustomization");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("users/teachers/expectations_customizer.scss");

@connect(
	(state, props) => {
		if (props.student) {
			var prefs = props.student.prefs;
		} else if (props.orgIdentifier) {
			var { type, key } = OrgTypes.fromIdentifier(props.orgIdentifier);

			if (type === OrgTypes.ALL_STUDENTS) {
				// Use one student lists's prefs as the overall defaults
				var prefs = RosterSelectors.nonEmptyStudentLists({ state, id: key })[0].prefs;

			} else if (type === OrgTypes.STUDENT_LIST) {
				var studentList = RosterSelectors.studentList({ state, id: key });
				var prefs = studentList.prefs;

			} else if (type === OrgTypes.SUBGROUP) {
				var subgroup = RosterSelectors.subgroup({ state, key: key });

				// Use one student in the group's prefs as the overall defaults
				var prefs = RosterSelectors.studentsForSubgroupKey({ state, subgroupKey: key })[0].prefs;
			}
		}

		return {
			studentList, subgroup,
			expectationsMetrics: prefs.expectations_metrics,
			expectationsTimePeriod: prefs.expectations_time_period,
			expectationsTimePeriodStarts: prefs.expectations_time_period_starts,
			recall_question_count: prefs.recall_question_count,
			analysis_question_count: prefs.analysis_question_count,
			sentence_starter_count: prefs.sentence_starter_count,
			schoolYearStartMonth: CurrentUser.get().prefs.school_year_start_month,
			asTeacherAdmin: CurrentUser.isTeacherAdmin()
		}
	},

	(dispatch, props) => ({
		onChange: (update, message) => {
			var { type, key } = OrgTypes.fromIdentifier(props.orgIdentifier);

			if (message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Update", text: message, icon: "ok-sign"
				});				
			}

			if (type === OrgTypes.ALL_STUDENTS) {
				return dispatch(RosterActions.updateAllStudentListPrefs({
					update, currentUserID: CurrentUser.get().id, resetStudents: true
				}));

			} else if (type == OrgTypes.STUDENT_LIST) {
				return dispatch(RosterActions.updateStudentListPrefs({
					update, studentListID: key, resetStudents: true
				}));

			} else if (type == OrgTypes.SUBGROUP) {
				return dispatch(RosterActions.massUpdateStudentPrefs({
					update, subgroupKey: key,
					embeds: ["student.prefs"]
				}));

			}
		}
	})
)
class ExpectationsCustomizer extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		// set defaults in onboarding, otherwise do normal checks
		if (props.onboardingDefault) {
			var forceChangesPending = true;
			var existingMetrics = ONBOARDING_DEFAULTS[props.onboardingDefault];
			var timePeriod = "month";

		} else {
			var forceChangesPending = false;

			// filter out any expectations the teacher shouldn't have
			var existingMetrics = _.reject(props.expectationsMetrics, (metricData) => {
				return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metricData.metric));
			});

			var timePeriod = props.expectationsTimePeriod;
		}

		this.state = {
			loading: false, overGoalLimit: false, changesPending: forceChangesPending,
			expectationsTimePeriod: timePeriod,
			expectationsTimePeriodStarts: props.expectationsTimePeriodStarts,
			expectationsMetrics: existingMetrics, allFrequencies: false,

			recallQuestionCount: props.recall_question_count,
			openQuestionCount: (props.analysis_question_count + props.sentence_starter_count),
			hasSentenceStarters: props.sentence_starter_count != 0
		};
	}

	validate() {
		var isValid = true;
		var currentMetrics = _.pluck(this.state.expectationsMetrics, "metric");
		_.each(currentMetrics, function(metric) {
			isValid = this.refs["goalInput" + metric].validate() && isValid;
		}.bind(this));

		if (this.state.recallQuestionCount + this.state.openQuestionCount == 0) {
			this.refs.quizErrors.setError("Select at least one of fill-in-the-blank or open-ended.")
			return false;
		}

		return isValid;
	}

	addQuizExpectations(preferenceHash) {
		var analysis_question_count = this.state.openQuestionCount;
		// ASSING QUESTION COUNT TO SENTENCE STARTERS IF ON
		if (this.state.hasSentenceStarters) {
			var sentence_starter_count = this.state.openQuestionCount
			analysis_question_count = 0
		} else {
			var sentence_starter_count = 0
		}

		var quizExpectations = {
			recall_question_count: this.state.recallQuestionCount,
			analysis_question_count: analysis_question_count,
			sentence_starter_count: sentence_starter_count
		}
		return _.extend(preferenceHash, quizExpectations)
	}
	handleSubmit(e) {
		$wr.nope(e)
		this.refs.quizErrors.reset();
		
		if (!this.validate()) {
			return;
		}

		if (this.props.askConfirmation) {
			var confirmMessage = "This will change goals for all your students";

			if (this.props.orgIdentifier) {
				var { type, key } = OrgTypes.fromIdentifier(this.props.orgIdentifier);

				if (type === OrgTypes.STUDENT_LIST) {
					confirmMessage += " in this class"

				} else if (type === OrgTypes.SUBGROUP) {
					confirmMessage += " in this group"
				}

			}

			if (!this.props.asTeacherAdmin) {
				confirmMessage += " and possibly override your teachers' settings"
			}
			confirmMessage += ".";

			if (!confirm(confirmMessage)) {
				return;
			}
		}

		this.setState({ loading: true, overGoalLimit: false });

		var newMetrics = []

		_.each(this.state.expectationsMetrics, (metricData) => {
			if (metricData.goal && metricData.goal > 0) {
				newMetrics.push(_.omit(metricData, "default"));
			}
		});

		var preferenceHash = {
			expectations_time_period: this.state.expectationsTimePeriod,
			expectations_time_period_starts: this.state.expectationsTimePeriodStarts,
			expectations_metrics: newMetrics,
		};
		preferenceHash = this.addQuizExpectations(preferenceHash)

		// simple onChange without notification if part of onboarding
		if (this.props.onboardingDefault) {
			this.props.onChange(preferenceHash);
		} else {
			this.props.onChange(preferenceHash, "You have successfully set your students' goals.", () => {
				this.setState({ loading: false, changesPending: false });
				$(window.document).trigger("expectations-updated")
			}).then(() => this.setState({ loading: false }));
		}

		if (this.props.afterChange) {
			this.props.afterChange(preferenceHash)
		}
	}

	//////////////////////////// methods for goalsForm ////////////////////////////
	getMetricIndex(metricType) {
		return _.findIndex(this.state.expectationsMetrics, function(metricHash) {
			return metricHash.metric == metricType;
		});
	}
	getMetric(metricType) {
		return this.state.expectationsMetrics[this.getMetricIndex(metricType)];
	}
	getMetricGoal(metricType) {
		return (this.getMetric(metricType) || {}).goal;
	}
	metricSelected(metricType) {
		return this.getMetric(metricType) != null;
	}
	toggleGoal(metricType) {
		if (this.metricSelected(metricType)) {
			var newMetrics = _.reject(this.state.expectationsMetrics, function(metricHash) {
				return metricHash.metric == metricType;
			});
		} else if (this.state.expectationsMetrics.length < 4) {
			var newMetrics = _.clone(this.state.expectationsMetrics);
			newMetrics.push({ metric: metricType, goal: DEFAULT_GOALS[metricType] });
		} else {
			this.setState({ overGoalLimit: true });
			return;
		}
		this.setState({ expectationsMetrics: newMetrics, changesPending: true, overGoalLimit: false });
	}
	updateGoalAmount(metricType, event) {
		var newMetrics = _.clone(this.state.expectationsMetrics);
		var goalValue = parseInt(event.target.value);

		if (this.getMetricIndex(metricType) != -1) {
			newMetrics[this.getMetricIndex(metricType)].goal = goalValue;
		} else {
			newMetrics.push({ metric: metricType, goal: goalValue });
		}
		this.setState({ expectationsMetrics: newMetrics, changesPending: true });
	}

	renderGoalInputForType(goalType) {

		if (goalType == StudentMetrics.TYPES.QUIZZES_PASSED) {
			var validators = [ValidatingInput.Validators.NON_NEGATIVE];
		} else {
			var validators = [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.POSITIVE_INTEGER];
		}

		var defaultGoal = this.getMetricGoal(goalType) ? this.getMetricGoal(goalType).toString() : "";

		return (
			<ValidatingInput ref={ "goalInput" + goalType }
				min="0"
				type="number" inputName="This goal"
				defaultValue={ defaultGoal }
				validators={ validators }
				onChange={ this.updateGoalAmount.bind(this, goalType) }
				inputClassName={ "form-control goalAmountBox goal-" + goalType } />
		);
	}
	getQuizExpectationMetrics(goalType) {
		
		switch(goalType) {
			case "recall-questions":
				return this.state.recallQuestionCount
			break;
			case "analysis-questions":
				return this.state.openQuestionCount;
			break;
			case "sentence-starters":
				return this.state.hasSentenceStarters ? "On" : "Off";
			break;
		}
	}

	updateQuizExpectations(goalType, e) {
		
		switch(goalType) {
			case "recall-questions":
				this.setState({ changesPending: true, recallQuestionCount: parseInt(e.target.value) })
			break;
			case "analysis-questions":
				this.setState({ changesPending: true, openQuestionCount: parseInt(e.target.value) })
			break;
			case "sentence-starters":
				this.setState({ changesPending: true, hasSentenceStarters: e.target.value == "On" })
			break;
		}
	}

	renderPerPeriod() {
		return (
			<span className="per">/{ this.state.expectationsTimePeriod }</span>
		);
	}
	renderQuizGoalSelector(goalType) {
		var options = StudentMetrics.getOptions(goalType)
		if (options) {
			var goalInput = (
				<select type="text" className="form-control"
					onChange={ this.updateQuizExpectations.bind(this, goalType) }
					value={ this.getQuizExpectationMetrics(goalType) }>
						{ options }
				</select>
			)
		} else {
			var goalInput = this.renderGoalInputForType(goalType);
		}

		var className = "formOption";

		if (goalType == StudentMetrics.TYPES.QUIZZES_PASSED) {
			var label = "Passing Quiz Goal";
			var perDisplay = this.renderPerPeriod();
			className += " withPer";

		} else if (goalType != StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS) {
			var label = StudentMetrics.getLabel(goalType);
			var perDisplay = (
				<span className="per">questions</span>
			);
			className += " withPer";

		} else {
			var label = StudentMetrics.getLabel(goalType);
		}
		
		return (
			<div className={ className } key={ goalType }>
				<label className="quizLabel">
					<span>{ label }</span>
				</label>
				<span className="quizInput">
					{ goalInput }{ perDisplay }
				</span>
			</div>
		);
	}
	renderPracticeGoalSelector(goalType) {
		var currentlySelected = this.metricSelected(goalType);
		if (currentlySelected) {
			var goalInput = this.renderGoalInputForType(goalType);
			var perPeriod = this.renderPerPeriod();

		} else if (this.state.expectationsMetrics.length == 4) {
			var maxClassName = "maxGoalsSelected";
		}

		return (
			<div className="formOption" key={ goalType }>
				<label className={ maxClassName }>
					<input type="checkbox" checked={ currentlySelected }
						onChange={ this.toggleGoal.bind(this, goalType) } />
					<span>{ StudentMetrics.getLabel(goalType) }</span>
				</label>
				{ goalInput }{ perPeriod }
			</div>
		);
	}

	renderQuizDuration() {
		var durationText = QuizCustomization.quizDuration(
			this.state.recallQuestionCount,
			this.state.openQuestionCount,
			this.state.hasSentenceStarters
		);

		return (
			<div className="lightGray">
				Based on your settings, quizzes should take { durationText } minutes.
			</div>
		)
	}

	//////////////////////////// end methods for goalsForm ////////////////////////////

	//////////////////////////// methods for frequencyForm ////////////////////////////
	selectTimePeriod(timePeriod) {
		if (timePeriod == $wr.Constants.PERIODS.WEEK) {
			var defaultPeriodStart = [0];
		} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
			var defaultPeriodStart = [1];
		} else {
			var startMonth = this.props.schoolYearStartMonth;
			var currentYear = (new Date()).getFullYear();
			var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];

			if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
			}
		}

		this.setState({
			expectationsTimePeriod: timePeriod,
			expectationsTimePeriodStarts: defaultPeriodStart,
			changesPending: true
		});
	}
	selectStartOfWeek(day) {
		this.setState({ expectationsTimePeriodStarts: [day], changesPending: true });
	}
	selectStartDate(periodStartPosition, periodStartDate) {
		var newPeriodStartsArray = _.clone(this.state.expectationsTimePeriodStarts);
		newPeriodStartsArray[periodStartPosition] = moment(periodStartDate).format("YYYY-MM-DD");
		this.setState({ expectationsTimePeriodStarts: newPeriodStartsArray, changesPending: true });
	}
	renderDatePickerForIndex(index) {
		return 	(
			<DatePicker className="startDatePicker"
				onChange={ this.selectStartDate.bind(this, index) } readOnly={ true }
				selected={ moment(this.state.expectationsTimePeriodStarts[index]) } />
		);
	}
	renderFrequencyStartSelect(frequencyType) {
		var currentPeriodStarts = this.state.expectationsTimePeriodStarts;

		if (frequencyType == $wr.Constants.PERIODS.WEEK) {
			var weekdayOptions = (
				DropDownOptions.Button.DaysOfWeek({
					includeWeeklyRange: true,
					buildOptionF: function(day) {
						return this.selectStartOfWeek.bind(this, day);
					}.bind(this)
				})
			);
			var currentWeekdayText = $wr.getDayOfWeek(currentPeriodStarts[0]) + " - " + $wr.getDayOfWeek((currentPeriodStarts[0] + 6) % 7);
			var freqStartSelect = (
				<div className="periodStartSelector">
					<span className="periodSelectorLabel">From:</span>
					<ButtonDropdown text={ currentWeekdayText }
						dropdownDisplay="link" className="formatControl">
						{ weekdayOptions }
					</ButtonDropdown>
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.QUARTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Quarter 1 Starts:
					{ this.renderDatePickerForIndex(0) }
					<br />
					Quarter 2 Starts:
					{ this.renderDatePickerForIndex(1) }
					<br />
					Quarter 3 Starts:
					{ this.renderDatePickerForIndex(2) }
					<br />
					Quarter 4 Starts:
					{ this.renderDatePickerForIndex(3) }
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.TRIMESTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Trimester 1 Starts:
					{ this.renderDatePickerForIndex(0) }
					<br />
					Trimester 2 Starts:
					{ this.renderDatePickerForIndex(1) }
					<br />
					Trimester 3 Starts:
					{ this.renderDatePickerForIndex(2) }
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.SEMESTER) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					Semester 1 Starts:
					{ this.renderDatePickerForIndex(0) }
					<br />
					Semester 2 Starts:
					{ this.renderDatePickerForIndex(1) }
				</div>
			);
		} else if (frequencyType == $wr.Constants.PERIODS.SCHOOL_YEAR) {
			var freqStartSelect = (
				<div className="periodStartSelector">
					School Year Starts:
					{ this.renderDatePickerForIndex(0) }
				</div>
			);
		} else {
			var freqStartSelect = <span></span>;
		}

		return freqStartSelect;
	}
	renderFrequencySelector(frequencyText, frequencyType) {
		var currentlySelected = (this.state.expectationsTimePeriod == frequencyType);
		if (currentlySelected) {
			var startSelect = this.renderFrequencyStartSelect(frequencyType);
		}
		return (
			<span key={ frequencyText }>
				<label className="formOption">
					<input type="radio" checked={ currentlySelected }
						onChange={ this.selectTimePeriod.bind(this, frequencyType) } />
					<span>{ frequencyText }</span>
				</label>
				{ startSelect }
			</span>
		);
	}
	expandFrequencies() {
		this.setState({ allFrequencies: true });
	}
	//////////////////////////// end methods for frequencyForm ////////////////////////////

	render() {
		if (this.props.onboardingDefault == null) {
			if (this.props.studentListID) {}
			var headerContent = (
				<p>
					Set goals for your students to complete.
				</p>
			);
		}

		var goalTextClassName = "hintText";
		if (this.state.overGoalLimit) {
			goalTextClassName += " goalError";
		}

		if (this.props.onboardingDefault) {
			var practiceActiveMetrics = ONBOARDING_METRICS;
			var practiceMetricSelectors = _.map(practiceActiveMetrics, this.renderPracticeGoalSelector);
		} else {
			var practiceActiveMetrics = _.reject(StudentMetrics.PRACTICE_EXPECTATION_METRICS, (metric) => {
				return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metric));
			});
			var quizActiveMetrics = _.reject(StudentMetrics.QUIZ_EXPECTATION_METRICS, (metric) => {
				return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metric));
			}); 
			var practiceMetricSelectors = _.map(practiceActiveMetrics, this.renderPracticeGoalSelector);
			var quizMetricSelectors = _.map(quizActiveMetrics, this.renderQuizGoalSelector);
		}

		if (this.props.onboardingDefault) {
			var goalsForm = (
				<div className="formColumn">
					<p className={ goalTextClassName }>
						<span className="hintHeader">Choose up to 2 goals.</span>
					</p>
					{ practiceMetricSelectors }
				</div>
			);

			if (this.state.allFrequencies) {
				var frequencyForm = (
					<div className="formColumn">
						<p className="hintText">
							<span className="hintHeader">Choose a time period.</span>
						</p>
						{ this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK) }
						{ this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH) }
						{ this.renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER) }
						{ this.renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER) }
						{ this.renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER) }
						{ this.renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR) }
					</div>
				);
			} else {
				var frequencyForm = (
					<div className="formColumn">
						<p className="hintText">
							<span className="hintHeader">Choose a time period.</span>
						</p>
						{ this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK) }
						{ this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH) }
						<a className="moreOptionsLink" href="#" onClick={ this.expandFrequencies }>
							More Options
						</a>
					</div>
				);
			}
		} else {
			// not during onboarding, still split on whether it's the assignment split test

			var quizGoalsForm = (
				<div className="quizFormColumn">
					<p className={ goalTextClassName }>
						<span className="hintHeader">Customize quizzes:</span>
						{ this.renderQuizDuration() }
						<ErrorDisplay ref="quizErrors" />
					</p>
					{ quizMetricSelectors }
				</div>
			);

			var practiceGoalsForm = (
				<div className="quizFormColumn">
					<p className={ goalTextClassName }>
						<span className="hintHeader">Customize supplemental tasks:</span>
						<br/>
						<span className="lightGray">(select up to 3)</span>
					</p>
					{ practiceMetricSelectors }
				</div>
			);

			var frequencyForm = (
				<div className="quizFormColumn">
					<p className="hintText">
						<span className="hintHeader">Choose a time period:</span>
					</p>
					{ this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK) }
					{ this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH) }
					{ this.renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER) }
					{ this.renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER) }
					{ this.renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER) }
					{ this.renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR) }
				</div>
			);
		}

		if (this.state.changesPending) {
			var buttonClassName = "center-block saveExpectationsButton"
			if (this.props.onboardingDefault) {
				buttonClassName += " buttonPrimary";
			} else {
				buttonClassName += " buttonSuccess";
			}
			var saveChangesButton = (
				<LoadingButton className={ buttonClassName } text="Save Goals"
					loading={ this.state.loading } />
			);
		}
		return (
			<div className="expectationsCustomizerContainer">
				{ headerContent }
				<form className="expectationsForm" onSubmit={ this.handleSubmit }>
					<div className="row">
						<div className="col-sm-6">
							{ quizGoalsForm }
							{ practiceGoalsForm }
						</div>
						<div className="col-sm-6 freqCol">
							{ frequencyForm }
						</div>
					</div>
					<div className="text-center">
						{ saveChangesButton }
					</div>
				</form>
			</div>
		)
	}

}

ExpectationsCustomizer.WrappedComponent.propTypes = StrictPropTypes({
	onboardingDefault: PropTypes.string,
	orgIdentifier: PropTypes.string,
	askConfirmation: PropTypes.bool,
	afterChange: PropTypes.func,

	// Data from @connect
	studentList: PropTypes.object,
	subgroup: PropTypes.object,
	expectationsMetrics: PropTypes.array,
	expectationsTimePeriod: PropTypes.string,
	expectationsTimePeriodStarts: PropTypes.array,
	schoolYearStartMonth: PropTypes.number,
	asTeacherAdmin: PropTypes.bool,

	// Handlers from @connect
	onChange: PropTypes.func.isRequired,

	recall_question_count: PropTypes.number.isRequired,
	analysis_question_count: PropTypes.number.isRequired,
	sentence_starter_count: PropTypes.number.isRequired
});

var DEFAULT_GOALS = {
	"quizzes-passed": 3,
	"questions": 4,
	"reviews": 4,
	"exercises": 2,
	"question-builder": 2,
	"minutes": 100,
	"pages": 100,
	"days-active": 10,
	"points": 10
};

var ONBOARDING_METRICS = [
	StudentMetrics.TYPES.QUIZZES_PASSED,
	StudentMetrics.TYPES.QUESTIONS,
	StudentMetrics.TYPES.REVIEWS,
	StudentMetrics.TYPES.DAYS_ACTIVE
];

var ONBOARDING_DEFAULTS = {
	"check-comprehension": [
		{ "goal": 1, "metric": "quizzes-passed" },
		{ "goal": 2, "metric": "questions" },
		{ "goal": 1, "metric": "reviews" }
	],
	"writing-practice": [
		{ "goal": 1, "metric": "quizzes-passed" },
		{ "goal": 4, "metric": "questions" }
	],
	"reading-motivation": [
		{ "goal": 2, "metric": "reviews" },
		{ "goal": 2, "metric": "questions" }
	]
}

module.exports = ExpectationsCustomizer;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/ExpectationsCustomizer.js